import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/mezoterapinin-igneli-bir-islem-olmasi-gercekler-faydalar-ve-guvenlik/page.tsx");
